import { render, staticRenderFns } from "./CruiseDetailStateroom.vue?vue&type=template&id=b2a98106&scoped=true"
import script from "./CruiseDetailStateroom.vue?vue&type=script&lang=js"
export * from "./CruiseDetailStateroom.vue?vue&type=script&lang=js"
import style0 from "./CruiseDetailStateroom.vue?vue&type=style&index=0&id=b2a98106&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2a98106",
  null
  
)

export default component.exports